import { render } from "./NotesTool.vue?vue&type=template&id=5bf8342a"
import script from "./NotesTool.vue?vue&type=script&lang=js"
export * from "./NotesTool.vue?vue&type=script&lang=js"

import "./NotesTool.vue?vue&type=style&index=0&id=5bf8342a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__